import { Link } from 'react-router-dom';

interface GameCardProps {
  title: string;
  description: string;
  imageUrl: string;
  playLink: string;
  highScore?: number;
}

const GameCard = ({ title, description, imageUrl, playLink, highScore }: GameCardProps) => {
  return (
    <div className="bg-slate-800 rounded-lg overflow-hidden shadow-lg">
      <img 
        src={imageUrl} 
        alt={title}
        className="w-full h-48 object-cover"
      />
      <div className="p-4">
        <h3 className="text-xl font-bold mb-2">{title}</h3>
        <p className="text-gray-400 mb-4">{description}</p>
        <div className="flex justify-between items-center">
          <Link 
            to={playLink}
            className="bg-indigo-500 px-4 py-2 rounded hover:bg-indigo-600"
          >
            Play Now
          </Link>
          {highScore !== undefined && (
            <span className="text-gray-400">
              High Score: {highScore}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default GameCard; 